import {LoginComponent} from 'appmodule/login/component/LoginComponent'

const App = () => <LoginComponent/>

export interface AppLoginProps {
	rootElementId: string,
	App: any,
}

export const AppModule: AppLoginProps = {
	rootElementId: 'ReactRoot',
	App,
};

